// extracted by mini-css-extract-plugin
export default {"iframe":"mAI_Hl"};